<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div>
            <span class="theme-color-one">ส่วนที่ 5 :</span> เอกสารแนบ
          </div>
          <Button
              theme="6"
              @onClick="addAttachment"
          >
            + เพิ่มไฟล์
          </Button>
        </div>

        <!-- Form 1 -->
        <div>
          <div class="theme-color-seven mb-3">
            *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 10 mb/ไฟล์)
          </div>

          <v-layout class="mt-3" v-for="(file, f) in attachment" :key="f">
            <v-flex xs7>
              <v-file-input
                  v-model="files[f]"
                  :id="'file' + f"
                  :rules="rulesFile"
                  color="#F15A29"
                  style="border-radius: 30px"
                  outlined
                  height="36"
                  placeholder=""
                  prepend-icon=""
                  accept="application/pdf,.doc,.docx"
                  v-show="
                      checkValType(file.file_name) == 'object' ||
                      file.file_name == '' ||
                      file.file_name == null
                    "
                  @change="addToAttachment(files[f])"
              ></v-file-input>
              <v-text-field
                  v-show="checkValType(file.file_name) == 'string'"
                  v-model="file.file_name"
                  outlined
                  height="36"
                  color="#F15A29"
                  style="border-radius: 30px"
                  readonly
              ></v-text-field>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn
                  depressed
                  dark
                  rounded
                  width="100"
                  color="#464647"
                  @click="selectFile(f)"
              >
                <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                <span class="font-12 font-w-700">อัพโหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn
                  depressed
                  height="35"
                  width="35"
                  fab
                  dark
                  color="#FD0C0C"
                  @click="removeFile(f)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

        </div>

      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import { eventBus } from "../../../plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "BFormAttachment",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: [],
      files: [],
      attachment: [{}],
      rulesFile: [
        (value) =>
            !value ||
            value.size < 10000000 ||
            "File size should be less than 10 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    }
  },
  computed: {
    ...mapState({
      AttachmentForm: state => state.AForm.AttachmentForm
    })
  },
  watch: {
    files: {
      handler (val) {
        this.form = this.attachment
        console.log('this.form@watch', this.form)
      },
      deep: true
    }
  },
  created () {
    if (this.isSameId) this.form = this.AttachmentForm
    eventBus.$on('bFormAttachment', () => {
      eventBus.$emit('bFormAttachmentSend', this.form)
    })

    eventBus.$on('bFormSummary', () => {
      this.$store.commit('BForm/addSummaryData', {
        partFiveAttachment: this.form
      })
    })

    if(this.masterData.form_b.attachments?.length > 0){
      this.form = this.masterData.form_b.attachments
      this.attachment = []
      //push each of this.masterData.form_c.attachments into this.attachment
      console.log('Attachment this.form', this.form)
      this.masterData.form_b.attachments.forEach((item) => {
        this.attachment.push(item)
        console.log('attachment@created', this.attachment)
      })
    }
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    addAttachment () {
      this.form = this.attachment
      console.log('addAttachment')
      this.attachment.push({})
    },
    addToAttachment(file){
      //add file in to last index of attachment
      this.attachment[this.attachment.length - 1] = file
      console.log('addToAttachment', this.attachment)
    },
    removeFile(id) {
      this.attachment.splice(id, 1);
      this.form = this.attachment
      console.log('removeFile', this.form)
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },
  }
}
</script>

<style scoped>

</style>